const EnvironmentEnum = {
  Local: 'local',
  Development: 'levelopment',
  Release: 'release',
  Production: 'production',
  Test: 'test',
};
export default EnvironmentEnum;
